module.exports = __webpack_public_path__ + "img/0147b7d.jpg";